import { render } from "./Devidos.vue?vue&type=template&id=9e4f794a"
import script from "./Devidos.vue?vue&type=script&lang=js"
export * from "./Devidos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__